import { InjectionToken } from '@angular/core';

import type { HelpTranslationLinkMapKey } from '@recruitee/help-articles';

export type TutorialStep = {
  imgUrl?: Promise<string>;
  imgUrl2x?: Promise<string>;
  youtubeVideoId?: string;
  title: string;
  description: string;
  articleLinkKey?: HelpTranslationLinkMapKey;
  isStep0?: boolean;
};

export type TutorialDialogContext =
  | 'multilang_intro'
  | 'referrals_onboarding'
  | 'requisitions_intro'
  | 'requisitions_job';

export type TutorialDialogAsset =
  | 'multilang-intro/multilang-intro-step-1.png'
  | 'multilang-intro/multilang-intro-step-1_2x.png'
  | 'multilang-intro/multilang-intro-step-2.png'
  | 'multilang-intro/multilang-intro-step-2_2x.png'
  | 'multilang-intro/multilang-intro-step-3.png'
  | 'multilang-intro/multilang-intro-step-3_2x.png'
  | 'referrals-onboarding/referrals-onboarding-step-0.svg'
  | 'referrals-onboarding/referrals-onboarding-step-2.svg'
  | 'referrals-onboarding/referrals-onboarding-step-3.svg'
  | 'referrals-onboarding/referrals-onboarding-step-4.svg'
  | 'requisitions-intro/requisitions-intro-step-1.svg'
  | 'requisitions-intro/requisitions-intro-step-2.svg'
  | 'requisitions-intro/requisitions-intro-step-3.svg'
  | 'requisitions-intro/requisitions-intro-step-4.svg'
  | 'requisitions-job/requisitions-job-step-1.svg'
  | 'requisitions-job/requisitions-job-step-2.svg';

export type AssetsProvider = (file: TutorialDialogAsset) => Promise<string>;

export const ASSETS_PROVIDER = new InjectionToken<AssetsProvider>('AssetsProvider');
